// apps/web/src/lib/kanban/preferencias.ts — Fase 11, Plano 17 (D-33).
// Preferências do quadro Kanban por usuário, em IndexedDB (Dexie). Web Storage é proibido (ADR-003).
import Dexie, { type Table } from 'dexie';
import { chaveFiltros, filtrosVazios, type FiltrosKanban } from './filtros';

interface PreferenciaRegistro {
  chave: string;
  valor: unknown;
}

export class PieltecKanbanPreferenciasDb extends Dexie {
  preferencias!: Table<PreferenciaRegistro, string>;

  constructor() {
    super('PieltecKanbanPreferenciasDb');
    this.version(1).stores({ preferencias: 'chave' });
  }
}

let banco: PieltecKanbanPreferenciasDb | null = null;

function obterBanco(): PieltecKanbanPreferenciasDb {
  banco ??= new PieltecKanbanPreferenciasDb();
  return banco;
}

function listaDeStrings(valor: unknown): string[] {
  return Array.isArray(valor) ? valor.filter((item): item is string => typeof item === 'string') : [];
}

/** Valida o que veio do disco: dados corrompidos ou de versões antigas viram filtros vazios/parciais. */
export function normalizarFiltrosSalvos(valor: unknown): FiltrosKanban {
  if (!valor || typeof valor !== 'object') return filtrosVazios();
  const bruto = valor as Record<string, unknown>;
  return {
    cliente: typeof bruto.cliente === 'string' && bruto.cliente.length > 0 ? bruto.cliente : null,
    prioridades: listaDeStrings(bruto.prioridades).filter(
      (nivel): nivel is FiltrosKanban['prioridades'][number] =>
        nivel === 'normal' || nivel === 'alta' || nivel === 'urgente',
    ),
    subtipos: listaDeStrings(bruto.subtipos),
    celulas: listaDeStrings(bruto.celulas),
  };
}

/** Falha de IndexedDB (modo privado, cota) nunca derruba o quadro: cai para filtros vazios. */
export async function carregarFiltros(userId: string): Promise<FiltrosKanban> {
  try {
    const registro = await obterBanco().preferencias.get(chaveFiltros(userId));
    return normalizarFiltrosSalvos(registro?.valor);
  } catch {
    return filtrosVazios();
  }
}

export async function salvarFiltros(userId: string, filtros: FiltrosKanban): Promise<void> {
  try {
    await obterBanco().preferencias.put({ chave: chaveFiltros(userId), valor: filtros });
  } catch {
    // Preferência é conveniência; falhar em salvar não impede o uso do quadro.
  }
}
